module.exports = __webpack_public_path__ + "img/new_index_cases18.c9f4080b.png";